import { type FieldValues, set, type UseFormGetValues, type UseFormSetValue } from 'react-hook-form';
import type { IGetNotificationPreferencesServiceResData } from '@/api/Notification/types';
import { HookToggle } from '@/components/UI/HookForm/Form/Toggle';
import { getFormFieldPath, isAllChecked } from '../helper';
import type { INotificationPreference, INotificationPreferenceTypes } from '../types';

export function Toggle({
  currentTab,
  data,
  notificationGroup,
  type,
  getValues,
  setValue,
}: {
  currentTab: string;
  data: IGetNotificationPreferencesServiceResData;
  notificationGroup: INotificationPreference;
  type: INotificationPreferenceTypes;
  getValues: UseFormGetValues<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
}) {
  const formFieldPath = getFormFieldPath(data, notificationGroup, type);
  const updateSelectAllCheckboxState = (newValue: boolean, notificationFor: string) => {
    const allNotifications = getValues();

    set(allNotifications, formFieldPath, newValue);
    setValue(`${notificationFor}.all.${type.slug}`, isAllChecked(currentTab, type.slug, allNotifications), {
      shouldDirty: true,
    });
  };

  return (
    <HookToggle
      key={type.slug}
      label={type.name}
      name={formFieldPath}
      onValueChange={(newValue) => updateSelectAllCheckboxState(newValue, data.notificationFor)}
    />
  );
}
